import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';

const MarketOverviewCard = ({ trendingStocks }) => {
  const bullish = trendingStocks.filter((s) => s.momentum === 'bullish').length;
  const bearish = trendingStocks.filter((s) => s.momentum === 'bearish').length;
  return (
    <Card data-testid="market-overview-card">
      <CardHeader>
        <CardTitle className="text-lg">Market Overview</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="flex justify-between items-center">
          <span className="text-gray-600">Trending Stocks</span>
          <span className="font-bold text-orange-600">{trendingStocks.length}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-gray-600">Bullish Signals</span>
          <span className="font-bold text-green-600">{bullish}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-gray-600">Bearish Signals</span>
          <span className="font-bold text-red-600">{bearish}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-gray-600">Data Source</span>
          <Badge variant="outline" className="text-xs">Yahoo Finance</Badge>
        </div>
      </CardContent>
    </Card>
  );
};

export default MarketOverviewCard;
